// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"2b12744f","349":"8b8c3071"}[chunkId] + ".css";
};